import React from 'react'
import { useNavigate } from 'react-router-dom';
import './Android.css'
import { FaArrowRight } from "react-icons/fa";
import android from './icons/android.png'
import { RiBarChartBoxLine } from "react-icons/ri";
import { IoIosTimer } from "react-icons/io";
import { GoShieldLock } from "react-icons/go";
import { FaBoxArchive } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { AiFillAndroid } from "react-icons/ai";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { FaTasks } from "react-icons/fa";
import { CiSettings } from "react-icons/ci";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { FiMessageCircle } from "react-icons/fi";
import { TbLayoutDashboard } from "react-icons/tb";
import { IoSpeedometerOutline } from "react-icons/io5";
import { BsBoxes, BsHeadset } from "react-icons/bs";
import { IoExtensionPuzzleOutline } from "react-icons/io5";
import { TbDeviceMobileSearch } from "react-icons/tb";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { MdOutlineDesignServices } from "react-icons/md";
import { HiOutlineCode } from "react-icons/hi";
import { LuClipboardCheck } from "react-icons/lu";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { IoChevronForward } from "react-icons/io5";
import checkmark from "./icons/checkmark.png"
import think from './icons/think.jpg'
import Header from './Header';
import Footer from './Footer';

function AndroidPage() {
  const navigate = useNavigate();

  // Navigation handler for contact page
  const handleNavigateToContact = () => {
    navigate('/contact');
  };

  return (
    <>
      <Header/>
      <section>
        <div className='android-hero-section'>
          <div className='android-hero-left'>
            <h1 className='android-hero-head'>
              Custom Android  <br />
              <span>
                App Development for <span className="android-highlight-word">Modern Businesses
                </span> <span className='android-apply'>Applications</span>
              </span>
            </h1>
            <div className='android-hero-paragraph'>
              <p className='android-hero-line0'>
                Build secure, scalable, and high-performance Android apps that drive business growth and enhance user experiences.
              </p>
              <hr className='android-hero-line' />
              <p className='android-hero-line1'>
                Alvanium develops custom Android applications with modern UI, reliable performance, and scalable architecture for businesses of all sizes.
              </p>
            </div>
            <div className="android-cta1-buttons">
              <button className="android-cta-btn android-secondary-btn" onClick={handleNavigateToContact}>Get Started</button>
            </div>
          </div>
          <div className='android-hero-right'>
            <img className='android-hero-mobile' src={android} alt="Android" />
          </div>
        </div>
      </section>

      <section className='android-overview-section'>
        <div className='android-overview-content'>
          <p className='android-overview-label'>Overview Section</p>
          <h2 className='android-bussines'>
            Android Apps That <br />
            <span className='android-modern'> Drive Business Growth</span>
          </h2>
          <p className='android-over-section'>
            We build custom Android apps that streamline business operations, improve customer engagement, and deliver seamless mobile experiences.
          </p>
          <div className='android-features-grid'>
            <div className='android-feature-item'>
              <span className='android-icon-box'><RiBarChartBoxLine /></span>
              <h5>Clean user interfaces</h5>
            </div>
            <div className='android-feature-item'>
              <span className='android-icon-box'><IoIosTimer /></span>
              <h5>Optimized performance</h5>
            </div>
            <div className='android-feature-item'>
              <span className='android-icon-box'><GoShieldLock /></span>
              <h5>Secure applications</h5>
            </div>
            <div className='android-feature-item'>
              <span className='android-icon-box'><FaBoxArchive /></span>
              <h5>Scalable architecture</h5>
            </div>
            <div className='android-feature-item'>
              <span className='android-icon-box'><AiFillAndroid /></span>
              <h5>Android applications</h5>
            </div>
            <div className='android-feature-item'>
              <span className='android-icon-box'><LuBriefcaseBusiness /></span>
              <h5>Business focused solutions</h5>
            </div>
          </div>
          <div className='android-devops'>
            <div className='android-devops-inner'>
              <p className='android-overview-devop'>Our Android App Development Services</p>
              <hr className='android-bodre-line' />
              <div className='android-cards-grid'>
                <div className='android-bussines-mobile'>
                  <div className='android-content'>
                    <div className='android-card-top'>
                      <span className='android-icon-wrap'><FaMobileAlt className='android-fa-icon' /></span>
                      <span className='android-card-number'>01</span>
                    </div>
                    <p className='android-app'>Business App Development</p>
                    <p>Build Android apps that improve business operations and team productivity.</p>
                  </div>
                </div>
                <div className='android-bussines-mobile'>
                  <div className='android-content'>
                    <div className='android-card-top'>
                      <span className='android-icon-wrap'><CiSettings className='android-fa-icon' /></span>
                      <span className='android-card-number'>02</span>
                    </div>
                    <p className='android-app'>Custom Android App Development</p>
                    <p>Develop Android apps tailored to your business goals and user needs.</p>
                  </div>
                </div>
                <div className='android-bussines-mobile'>
                  <div className='android-content'>
                    <div className='android-card-top'>
                      <span className='android-icon-wrap'><FaTasks className='android-fa-icon' /></span>
                      <span className='android-card-number'>03</span>
                    </div>
                    <p className='android-app'>Task Management Apps</p>
                    <p>Create apps that simplify task management and team collaboration.</p>
                  </div>
                </div>
                <div className='android-bussines-mobile'>
                  <div className='android-content'>
                    <div className='android-card-top'>
                      <span className='android-icon-wrap'><FiMessageCircle className='android-fa-icon' /></span>
                      <span className='android-card-number'>04</span>
                    </div>
                    <p className='android-app'>Customer Service Apps</p>
                    <p>Build mobile apps that enhance customer communication and support.</p>
                  </div>
                </div>
                <div className='android-bussines-mobile'>
                  <div className='android-content'>
                    <div className='android-card-top'>
                      <span className='android-icon-wrap'><MdOutlineMapsHomeWork className='android-fa-icon' /></span>
                      <span className='android-card-number'>05</span>
                    </div>
                    <p className='android-app'>Enterprise Android Apps</p>
                    <p>Develop secure and scalable Android applications for enterprise businesses.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className='android-featurs-section'>
          <h2>Key Features</h2>
          <hr className='android-underline' />
        </div>
        <div className='android-features-section'>
          <div className='android-feature-card'>
            <div className='android-feature-icon-box android-blue'><TbLayoutDashboard /></div>
            <h5 className='android-feature-title'>Modern UI & UX</h5>
            <hr className='android-feature-underline' />
          </div>
          <div className='android-feature-card'>
            <div className='android-feature-icon-box android-green'><GoShieldLock /></div>
            <h5 className='android-feature-title'>Secure Architecture</h5>
            <hr className='android-feature-underline' />
          </div>
          <div className='android-feature-card'>
            <div className='android-feature-icon-box android-orange'><IoSpeedometerOutline /></div>
            <h5 className='android-feature-title'>High Performance</h5>
            <hr className='android-feature-underline' />
          </div>
          <div className='android-feature-card'>
            <div className='android-feature-icon-box android-purple'><BsBoxes /></div>
            <h5 className='android-feature-title'>Scalable Development</h5>
            <hr className='android-feature-underline' />
          </div>
          <div className='android-feature-card'>
            <div className='android-feature-icon-box android-pink'><BsHeadset /></div>
            <h5 className='android-feature-title'>Maintenance & Support</h5>
            <hr className='android-feature-underline' />
          </div>
        </div>

        <div className="android-orbit-section">
          <h2 className="android-orbit-title">Our Development Process</h2>
          <p className="android-orbit-subtitle">A clear five-step journey from idea to launch — crafted with precision, tested with care.</p>
          <div className="android-timeline-wrapper">
            <div className="android-timeline-line"></div>
            <div className="android-timeline-item">
              <div className="android-timeline-card">
                <div className="android-icon"><HiOutlineDocumentSearch /></div>
                <h4>Discovery</h4>
                <p>Understand your business requirements.</p>
              </div>
              <div className="android-connector"></div>
              <div className="android-step-dot">01</div>
            </div>
            <div className="android-timeline-item android-bottom">
              <div className="android-step-dot">02</div>
              <div className="android-connector"></div>
              <div className="android-timeline-card">
                <div className="android-icon"><MdOutlineDesignServices /></div>
                <h4>UI / UX Design</h4>
                <p>Design intuitive and engaging user experiences.</p>
              </div>
            </div>
            <div className="android-timeline-item android-top">
              <div className="android-timeline-card">
                <div className="android-icon"><HiOutlineCode /></div>
                <h4>Development</h4>
                <p>Build secure and scalable Android applications.</p>
              </div>
              <div className="android-connector"></div>
              <div className="android-step-dot">03</div>
            </div>
            <div className="android-timeline-item android-bottom">
              <div className="android-step-dot">04</div>
              <div className="android-connector"></div>
              <div className="android-timeline-card">
                <div className="android-icon"><LuClipboardCheck /></div>
                <h4>Testing</h4>
                <p>Optimize performance, security, and quality.</p>
              </div>
            </div>
            <div className="android-timeline-item android-top">
              <div className="android-timeline-card">
                <div className="android-icon"><HiOutlineRocketLaunch /></div>
                <h4>Launch & Support</h4>
                <p>Deploy your app and provide ongoing support.</p>
              </div>
              <div className="android-connector"></div>
              <div className="android-step-dot">05</div>
            </div>
          </div>
        </div>
      </section>

      <section className='android-why-section'>
        <div className='android-why-container'>
          <div className='android-why-left'>
            <h1 className='android-alvainum'>Why Choose<br /><span className='android-apply'>Alvanium</span></h1>
            <div className='android-chek-box'>
              <ul>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Custom Android App Development
                </li>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Experienced Development Team
                </li>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Scalable Solutions
                </li>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Secure Architecture
                </li>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Performance Optimization
                </li>
                <li className='android-container-start'>
                  <img className='android-checkmark' src={checkmark} alt="" />
                  Long-Term Support
                </li>
              </ul>
            </div>
          </div>
          <div className='android-why-right'>
            <img className='android-why-image' src={think} alt="Why choose Alvanium" />
          </div>
        </div>
      </section>

      <section className="android-cta-section">
        <div className="android-cta-content">
          <h2>Ready To Build Your Android App?</h2>
          <p>Let's build a custom Android application that helps your business grow and deliver better mobile experiences.</p>
          <div className="android-cta-buttons">
            <button className="android-cta-btn android-secondary-btn" onClick={handleNavigateToContact}>Contact Us</button>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default AndroidPage;